import React from "react";

const ARROW_STYLE = {
    fontFamily: 'Figtree, "Open Sans", Helvetica, Arial, sans-serif',
    fontSize: "19px",
    fontWeight: 400,
    lineHeight: 1,
};

const BackArrow = () => (
    <span style={ARROW_STYLE} aria-hidden="true">
        &#8592;
    </span>
);

export default BackArrow;
